import {all, call, fork, put, takeLatest} from 'redux-saga/effects';
import Api from './api';
import actions from './actions';
import pageActions from '../pages/actions';

const API = new Api();

function* getBranches() {
    yield takeLatest(actions.GET_BRANCHES, function* (action) {
        try {
            const {data} = action;
            const response = yield call(API.getBranches, data);
            if (response && response.status === 200) {
                if(response.data.autoComplete){
                    yield put(actions.setNetworkAutocomplete(response.data.autoComplete));
                } else {
                    yield put(pageActions.setModule(response.data));
                }
            }
        } catch (e) {
            const message = {
                title: "Error",
                message: e.message,
                type: "danger"
            };
            console.log(message);
        }
    });

}

function* OurNetwork() {
    yield all([
        fork(getBranches)
    ]);
}

export default OurNetwork;